import { Navigate, Route, Routes } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from './auth/useAuth';
import { HelloPage } from './pages/HelloPage';
import { AccessDeniedPage } from './pages/AccessDeniedPage';
import { PortfolioPage } from './pages/PortfolioPage';
import { TablePage } from './pages/TablePage';
import { DashboardPage } from './pages/DashboardPage';
import { AnchorsPage } from './pages/AnchorsPage';
import { HelpPage } from './pages/HelpPage';
import { AdminCategoriesPage } from './pages/AdminCategoriesPage';

// Any signed-in user with at least one MAS-Flow role can browse /portfolio.
// Per-capability gating inside the page hides controls Viewers/Scorers can't operate.
function RequireSignedInWithRole({ children }: { children: ReactNode }) {
  const { status, roles } = useAuth();
  if (status === 'loading') return <p className="text-slate-600">Loading…</p>;
  if (status !== 'signed-in') return <Navigate to="/" replace />;
  if (roles.length === 0) return <Navigate to="/access-denied" replace />;
  return <>{children}</>;
}

export function AppRoutes() {
  const { status, roles } = useAuth();
  return (
    <Routes>
      <Route path="/" element={<HelloPage />} />
      <Route
        path="/portfolio"
        element={
          <RequireSignedInWithRole>
            <PortfolioPage />
          </RequireSignedInWithRole>
        }
      />
      <Route
        path="/table"
        element={
          <RequireSignedInWithRole>
            <TablePage />
          </RequireSignedInWithRole>
        }
      />
      <Route
        path="/dashboard"
        element={
          <RequireSignedInWithRole>
            <DashboardPage />
          </RequireSignedInWithRole>
        }
      />
      <Route
        path="/anchors"
        element={
          <RequireSignedInWithRole>
            <AnchorsPage />
          </RequireSignedInWithRole>
        }
      />
      <Route
        path="/help"
        element={
          <RequireSignedInWithRole>
            <HelpPage />
          </RequireSignedInWithRole>
        }
      />
      <Route
        path="/admin/categories"
        element={
          <RequireSignedInWithRole>
            <AdminCategoriesPage />
          </RequireSignedInWithRole>
        }
      />
      <Route path="/access-denied" element={<AccessDeniedPage />} />
      <Route
        path="*"
        element={
          status === 'signed-in' && roles.length === 0 ? (
            <Navigate to="/access-denied" replace />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
    </Routes>
  );
}
